import React from 'react';

export type State<S> = [S, (newValue: S) => void];

export interface GlobalStoreContextProps {
  projectId: State<string | null>;
  rawProjectId?: string;
  displayId: [string | undefined | null, (id: string | null) => void];
}

export const GlobalStoreContext = React.createContext<GlobalStoreContextProps | null>(null);

export default function useGlobalStoreContext() {
  const context = React.useContext(GlobalStoreContext);
  if (!context) {
    throw new Error('useGlobalStoreContext must be used within a GlobalStoreContextProvider');
  }
  return context;
}
